<template>
  <div
    class="event-kind-card row flex align-center rounded py-2 px-4"
    :class="
      kind.active
        ? 'tournament-light-blue-outline tournament-white elevate-3d elevate-3'
        : 'tournament-grey-outline tournament-disabled'
    "
  >
    <div class="column flex">
      <!-- Event Kind Title -->
      <div
        v-if="kind.title"
        :class="
          kind.active ? 'tournament-light-blue--text' : 'tournament-grey--text'
        "
        class="column headline flex pl-2 mr-2 mb-2 ellipsis"
      >
        {{ kind.title }}
      </div>

      <!-- kind Description -->
      <div
        v-if="kind.description"
        class="column tournament-grey--text body-1 flex pl-2 mr-2"
      >
        {{ kind.description }}
      </div>
    </div>

    <div
      v-if="kind.level && !$vuetify.breakpoint.smAndDown"
      class="column align-center justify-center border-left"
      style="min-width: 120px; height: 100%"
    >
      <div class="arrows row">
        <i
          v-for="index in 3"
          :key="index"
          :class="
            kind.level >= index && kind.active
              ? 'tournament-light-blue--text'
              : 'tournament-grey--text'
          "
          class="column material-icons arrow-level"
        >
          keyboard_arrow_right
        </i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EventKindCard",
  props: {
    kind: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.event-kind-card {
  min-height: 120px;
  max-height: 160px;
  border-left: 8px solid;
}

.arrow-level {
  font-size: 60px;
  width: 20px;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Events/Cards/Kind.vue